import { Dispatch } from "react";
import { ErrorResponse } from "../interfaces/Response";

export const fieldHasErrors = (fieldName: string, errors: ErrorResponse | null) => {
  if (errors && errors.errors && errors.errors[fieldName] && errors.errors[fieldName].length > 0) {
    return true;
  }
  return false;
}

export const fieldErrorMessage = (fieldName: string, errors: ErrorResponse | null) => {
  if (errors && errors.errors && errors.errors[fieldName]) {
    const fieldErrors = errors.errors[fieldName];
    if (fieldErrors.length === 1) {
      return fieldErrors[0];
    } else {
      return (
        <ul>
          {fieldErrors.map(item => {
            return <li>{item}</li>
          })}
        </ul>
      );
    }
  }
  return "";
}

export const clearError = (fieldName: string, errors: ErrorResponse | null, setError: any, dispatch: Dispatch<any>) => {
  if (errors) {
    dispatch(setError({
      ...errors,
      errors: {
        ...errors.errors,
        [`${fieldName}`]: []
      }
    }));
  }
}